<template>
  <ul :class="styles.list">
    <template v-for="(item, index) in items">
      <li
        :key="index"
        v-if="getShowFlags(item.url)"
        :class="styles.item(selectedPath === item.url)"
        @click="onClick(item.url)"
      >
        <div :class="styles.titleWrapper">
          <div :class="styles.iconWrapper">
            <img
              :src="item.image"
              :width="item.width"
              :height="item.height"
              alt=""
              class="md-image"
            />
          </div>
          <div>{{ item.title }}</div>
        </div>
      </li>
    </template>
  </ul>
</template>

<script>
import styles from '@/components/Shared/Drawer/drawerStyles'

export default {
  name: 'DrawerPresentational',
  props: {
    items: Array,
    getShowFlags: Function,
    routerPush: Function,
  },
  created() {
    this.selectedPath = this.$route.path
  },
  data() {
    return {
      selectedPath: '',
    }
  },
  computed: {
    color() {
      return this.$store.getters['colorTheme/color']
    },
    styles() {
      return styles(this.color)
    },
  },
  watch: {
    $route() {
      this.selectedPath = this.$route.path
    },
  },
  methods: {
    onClick(path) {
      this.routerPush(path)
    },
  },
}
</script>

<style scoped></style>
